import React from 'react';
import useSweetAlert from '../../../hooks/useSweetAlert';
import { WarehouseOrderItemStatus } from '../../../app/models/WarehouseOrderItemStatus';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import useWarehouseOrderItemService from '../../../app/services/hooks/useWarehouseOrderItemService';
import { WarehouseOrderItemStatuses } from '../../../app/shared/enums';

interface Props {
    warehouseOrderItemId: number;
    statuses: WarehouseOrderItemStatus[];
    selectedStatus: WarehouseOrderItemStatus;
    reloadModule?: () => void;
    callbackSuccess?: () => void;
}

const WarehouseOrderItemChangeStatus = ({
    warehouseOrderItemId,
    statuses,
    selectedStatus,
    callbackSuccess,
    reloadModule
}: Props) => {
    const [selected, setSelected] = React.useState<WarehouseOrderItemStatus>(selectedStatus);

    const {
        changeToPreparationStatusWarehouseOrderItem,
        changeToDispatchStatusWarehouseOrderItem,
        changeToFinishStatusWarehouseOrderItem,
        changeToAnnulledStatusWarehouseOrderItem
    } = useWarehouseOrderItemService();

    const changeStatus = (value: string) => {
        if (value === selected.id) return null;
        const _status = statuses.find((status: WarehouseOrderItemStatus) => status.id == value);

        if (_status?.id === WarehouseOrderItemStatuses.PREPARACION) {
            changeStatusToPreparation(_status);
        } else if (_status?.id === WarehouseOrderItemStatuses.DESPACHO) {
            changeStatusToDispatch(_status);
        } else if (_status?.id === WarehouseOrderItemStatuses.FINALIZADO) {
            changeStatusToFinish(_status);
        } else if (_status?.id === WarehouseOrderItemStatuses.ANULADO) {
            changeStatusToAnnulled(_status);
        }
    };

    const changeStatusToPreparation = (_status: any) => {
        const _text = `Está a punto de cambiar el estado de la posición de pedido #${warehouseOrderItemId} a ${_status?.name}.`;
        changeStatusAlert(_status, _text, () =>
            changeToPreparationStatusWarehouseOrderItem(
                warehouseOrderItemId,
                _status.id,
                changeStatusEvent(_status)
            )
        );
    };

    const changeStatusToDispatch = (_status: any) => {
        const _text = `Está a punto de cambiar el estado de la posición de pedido #${warehouseOrderItemId} a ${_status?.name}.`;
        changeStatusAlert(_status, _text, () =>
            changeToDispatchStatusWarehouseOrderItem(
                warehouseOrderItemId,
                _status.id,
                changeStatusEvent(_status)
            )
        );
    };

    const changeStatusToFinish = (_status: any) => {
        const _text = `Está a punto de cambiar el estado de la posición de pedido #${warehouseOrderItemId} a ${_status?.name}.`;
        changeStatusAlert(_status, _text, () =>
            changeToFinishStatusWarehouseOrderItem(
                warehouseOrderItemId,
                _status.id,
                changeStatusEvent(_status)
            )
        );
    };

    const changeStatusToAnnulled = (_status: any) => {
        const _text = `Está a punto de Anular la posición de pedido #${warehouseOrderItemId}, esta cambiará a estado Despacho.`;
        changeStatusAlert(_status, _text, () =>
            changeToAnnulledStatusWarehouseOrderItem(
                warehouseOrderItemId,
                _status.id,
                changeStatusEvent(_status)
            )
        );
    };

    const changeStatusAlert = (_status: any, _text: string, _onConfirm: () => void) => {
        useSweetAlert().requestConfirmation({
            title: '¿Está seguro?',
            text: _text,
            confirmButtonText: 'Sí, cambiar estado',
            cancelButtonText: 'Cancelar',
            onConfirm: () => {
                useSweetAlert().spinnerAlert('Cambiando estado...');
                _onConfirm(); 
            },
            onCancel: () => {
                useSweetAlert().infoAlert({
                    title: 'Cancelado',
                    text: 'El estado del pedido no se ha cambiado.'
                });
                setSelected(selectedStatus);
            }
        });
    };

    const changeStatusEvent = (_status: any) => {
        return {
            onSuccess: (response: ServiceResponse) => {
                useSweetAlert().closeSpinnerAlert();
                setSelected(_status ?? selected);

                if (reloadModule) reloadModule();
                if (callbackSuccess) callbackSuccess();

                toast.success(response.message);
            },
            onError: (response: ServiceResponse) => {
                useSweetAlert().errorAlert({
                    title: 'Error',
                    text: response.message
                });
                setSelected(selected);
                toast.error(response.message);
            }
        };
    };

    if (!selectedStatus) return null;

    return (
        <select
            className="form-control"
            value={selected.id}
            onChange={(e) => changeStatus(String(e.target.value))}
        >
            <option key={selected.id} value={selected.id}>
                {selected.name}
            </option>
            {statuses
                .filter((status) => status.id !== selected.id)
                .map((status) => (
                    <option key={status.id} value={status.id}>
                        {status.name}
                    </option>
                ))}
        </select>
    );
};

export default WarehouseOrderItemChangeStatus;
